import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adminQueryKeys, Admins } from '#api';

export function useAddAdminMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (variables: Admins.AddAdminVariables) => Admins.addAdmin(variables),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: adminQueryKeys.lists() });
    },
  });
}
